module.exports = __webpack_public_path__ + "img/agree.7e7c3478.png";